import Box from '@mui/material/Box';
import BreadcrumbsBar from "../../layouts/breadcrumb/BreadcrumbsBar";
import styles from './AiChatAssistantNew.module.scss';
import Card from "../../common/card/Card";
import { v4 as uuidv4 } from 'uuid';
import ChatSidebar from './ChatSidebar';
import { useState } from "react";

// A simple status component to show when the assistant is thinking
import ActiveChatSession from './ActiveChatSession';

const AiChatAssistantNew = () => {
    // Generate a unique conversation ID when the component mounts
    // Use a ref or just state to key the conversation
    const [currentConversationId, setCurrentConversationId] = useState(() => uuidv4());
    const [selectedConversation, setSelectedConversation] = useState(null);

    const handleSelectConversation = (conversation) => {
        setSelectedConversation(conversation);
    };

    const handleNewChat = () => {
        setSelectedConversation(null);
        setCurrentConversationId(uuidv4());
    };

    // Determine what to show
    // If selectedConversation is present, show that in read-only mode (or whatever mode is appropriate for history)
    // If not, show the current active "new" session

    // We use a key to force re-mounting of the runtime provider when switching conversations
    const activeKey = selectedConversation ? selectedConversation.conversationId : currentConversationId;
    const initialMessages = selectedConversation ? selectedConversation.messages : undefined;

    console.log('AiChatAssistantNew render:', {
        activeKey,
        hasSelected: !!selectedConversation,
        initialMessagesLen: initialMessages?.length
    });

    const isReadOnly = !!selectedConversation;

    return (
        <div className={styles.container}>
            <BreadcrumbsBar />
            <Card title="InfluioGPT" customStyles={{ cardBody: styles.noPadding }}>
                <Box sx={{ p: 0, height: 'calc(100vh - 200px)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

                    <Box sx={{ flexGrow: 1, p: 0, display: 'flex', justifyContent: 'center', overflow: 'hidden' }}>
                        <div style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'row', // Change to row for sidebar layout
                            overflow: 'hidden'
                        }}>
                            <ChatSidebar onSelect={handleSelectConversation} onNewChat={handleNewChat} selectedId={selectedConversation?.conversationId} />
                            <div style={{
                                flexGrow: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                height: '100%',
                                width: '80%'
                            }}>
                                <ActiveChatSession
                                    key={activeKey}
                                    conversationId={activeKey}
                                    initialMessages={initialMessages}
                                    readOnly={isReadOnly}
                                />
                            </div>
                        </div>
                    </Box>
                </Box>
            </Card>
        </div>
    );
};

export default AiChatAssistantNew;
